import SC from 'styled-components'

export const FormWrapper = SC.div`
  padding: 20px 30px 32px 30px;
`

export const NameWrapper = SC.div`
  width: 270px
`
